import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

class LoadAnimation {
  constructor(component) {
    this.refs = {
      header: '.js-header',
      video: '.js-video',
      hero: '.js-homepage-hero',
    };

    this.dom = {
      $component: component,
      $main: document.querySelector('main'),
      $header: document.querySelector(this.refs.header),
      $video: component.querySelector(this.refs.video),
      $hero: document.querySelector(this.refs.hero),
    };

    this.state = {
      innerHeight: null,
    };
    
    this.init();
  }

  init() {
    const { dom, state } = this;    
    let loadAnimationCookie = this.getCookie("LoadAnimation");

    if (loadAnimationCookie) {
      dom.$component.remove();
      return;
    }

    this.mount();

    gsap.registerPlugin(ScrollToPlugin);

    this.setInnerHeight();

    this.setLoadAnimationCookie();

    this.startLoadAnimation();

    // fix for safari bug
    setTimeout(() => {
      dom.$component.classList.add('is-active');
    }, 200);
  }

  mount() {
    const { dom } = this;
    
    dom.$video.addEventListener('ended', this.endLoadAnimation.bind(this));

    window.addEventListener('resize', this.onResize.bind(this));
  }

  startLoadAnimation() {
    const { dom, state } = this;

    dom.$header.classList.add('load-animation-active');
    document.body.classList.add('scroll-locked');
    dom.$main.classList.add('has-load-animation');
    dom.$main.classList.add('load-animation-active');
    dom.$component.style.height = state.innerHeight + 'px';
    history.scrollRestoration = "manual";
    window.scrollTo(0, 0);
    dom.$video.play();

    const playResult = dom.$video && typeof dom.$video.play === 'function' ? dom.$video.play() : null;
    if (playResult !== null) {
      playResult.catch(() => {
        // Autoplay was prevented, end the load animation immediately
        this.endLoadAnimation();
      });
    }
  }

  endLoadAnimation() {
    const { dom } = this;
    const componentHeight = dom.$component.offsetHeight;

    document.body.classList.remove('scroll-locked');
    dom.$main.classList.remove('load-animation-active');

    gsap.to(window, {
      duration: 1.8,
      scrollTo: { y: componentHeight - 65, autoKill: false },
      ease: "Power1.easeInOut",
      onComplete: this.onLoadAnimationComplete.bind(this)
    });
  }

  onLoadAnimationComplete() {
    const { dom } = this;
    
    dom.$component.remove();
    dom.$header.classList.remove('load-animation-active');
    window.scrollTo(0, 0);
  }


  onResize(){
    const { dom, state } = this;
    if (state.innerHeight === window.innerHeight) return;

    this.setInnerHeight();

    if (!dom.$component) return;
    
    dom.$component.style.height = state.innerHeight + 'px';
  }

  setInnerHeight() {
    const { state } = this;
    state.innerHeight = window.innerHeight;
  }

  setLoadAnimationCookie() {
    // Set a cookie that expires in 7 days
    const d = new Date();
    d.setTime(d.getTime() + (7 * 24 * 60 * 60 * 1000)); // 7 days in milliseconds
    let expires = "expires=" + d.toUTCString();
    document.cookie = "LoadAnimation=true;" + expires + ";path=/"; // Setting path=/ makes it available to the whole site
  }

  getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length); // Remove leading spaces
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

const $loadAnimation = document.querySelector('.js-load-animation');
if ($loadAnimation) new LoadAnimation($loadAnimation);